<template>
    <div class="content-box">
      <div class="box-heading">
        <h3>Participants</h3>
      </div>
      <div class="box-content">
        <ul>
          <li v-for="name in instanceData.names" :key="name.id">
            <div class="list-item">
              <span>{{ name.name }}</span>
              <span class="status-container">
                <span v-if="!isConnected(name.id)" class="state disconnected">Disconnected</span>
                <span v-else-if="instanceData.state.moveOn.includes(name.id) && instanceData.state.state === 'things'" class="state done">Done adding</span>
                <span v-else-if="instanceData.state.state === 'rank' && instanceData.state.moveOn.includes(name.id)" class="state done">Done rating</span>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>

export default {
  props: {
    instanceData: {
      type: Object,
      default: null
    },
  },
  computed: {
    isConnected() {
      return (userId) => {
        const connected = this.instanceData.connectedParticipants || [];
        return connected.includes(userId);
      };
    }
  }
};
</script>

<style scoped>

ul {
  list-style-type: none;
  padding: 0;
  margin-top: 10px;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
}

li:last-child .list-item {
  border-bottom: none;
}

.status-container {
  display: flex;
  gap: 8px;
}

.state {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.state.done {
  background-color: #27ae60;
  color: white;
}

.state.disconnected {
  background-color: #e74c3c;
  color: white;
}

</style>
